import React from 'react';
import { Link } from 'react-router-dom';
import MkFaq from '../MkFaq';
import { HOME_FAQ } from '../../../marketing/faq';

// H10 — plain HTML FAQ (no FAQPage JSON-LD). <details> carry no reveal classes.
const HomeFaq = () => (
  <section className="mk-faqsec section" id="faq" aria-labelledby="mk-faq-title">
    <div className="container-xs">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <h2 id="mk-faq-title" className="mk-h2">
            Questions, answered
          </h2>
        </div>
        <MkFaq items={HOME_FAQ} page="home" />
        <p className="mk-faqsec__more">
          <Link className="mk-textlink" to="/Help">
            More answers in Help →
          </Link>
        </p>
      </div>
    </div>
  </section>
);

export default HomeFaq;
